import type { IconData } from '@stacksjs/iconify-core'

export const se1x1: IconData = {
  "body": "<path fill=\"#005293\" d=\"M0 0h512v512H0z\"/><path fill=\"#fecb00\" d=\"M134 0v204.8H0v102.4h134V512h102.4V307.2H512V204.8H236.4V0z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default se1x1
